import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import "./styles.css";
import "./fonts.css"; // self-hosted Tamil / Devanagari / display fonts
import { TvApp } from "./tv/TvApp";
import { JoinApp } from "./phone/JoinApp";
import { AdminApp } from "./admin/AdminApp";
import { Stage } from "./tv/Stage";
import { SensorLab } from "./phone/SensorLab";
import { HostingHelp } from "./quality/HostingHelp";
import { PhoneGate, PhoneHome } from "./tv/PhoneGate";
import { screenForm } from "./device";
import "./install"; // catches the browser's one-time install event as early as possible
import { GameBoundary, reloadForNewVersion } from "./GameBoundary";

// a lazily loaded file (a game, the showroom) that vanished in a deploy: reload once to get the new build
window.addEventListener("vite:preloadError", (e) => { if (reloadForNewVersion()) e.preventDefault(); });

// the showroom pulls in three.js and the 3D kits: loaded only when opened
const Showroom = lazy(() => import("./showroom/Showroom"));
const loading = <div className="tv"><div className="center-screen"><p className="hint">Loading…</p></div></div>;

function Home() {
  return (
    <div className="tv">
      <div className="center-screen">
        <div style={{ display: "flex", flexDirection: "column", gap: "1.2em", alignItems: "center" }}>
          <img src="/icons/icon-192.png" alt="" width={120} height={120} style={{ borderRadius: 28 }} />
          <h1 className="big-title">Play With TV</h1>
          <p className="hint">Open this page on the TV, then scan the code with your phone. No app needed.</p>
          <div className="row">
            <Link className="btn" to="/tv" autoFocus>This is the TV</Link>
            {/* a full page load: the phone page has its own security headers (camera for camera games) */}
            <Link className="btn secondary" to="/join" reloadDocument>Join with my phone</Link>
          </div>
          <p className="credit" style={{ fontSize: "0.7em" }}>Play With TV · by <b>Leadup Technologies</b> · Abishek Sivakumar</p>
        </div>
      </div>
    </div>
  );
}

// Installable app + instant repeat visits (production only: the dev server must never be cached).
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <GameBoundary what="this page">
      <Routes>
        <Route path="/" element={screenForm() === "phone" ? <PhoneHome /> : <Stage><Home /></Stage>} />
        <Route path="/tv" element={<PhoneGate><Stage><TvApp /></Stage></PhoneGate>} />
        <Route path="/tv/showroom" element={<Stage><Suspense fallback={loading}><Showroom /></Suspense></Stage>} />
        <Route path="/tv/hosting" element={<Stage><HostingHelp /></Stage>} />
        <Route path="/play" element={<PhoneGate><Stage><TvApp /></Stage></PhoneGate>} />
        <Route path="/join" element={<JoinApp />} />
        <Route path="/controller" element={<JoinApp />} />
        <Route path="/admin" element={<AdminApp />} />
        <Route path="/sensors" element={<SensorLab />} />
      </Routes>
      </GameBoundary>
    </BrowserRouter>
  </StrictMode>,
);
